// frontend/src/components/common/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const YEAR = new Date().getFullYear();

export default function Footer() {
  return (
    <footer className="mt-auto py-4 px-4 text-center text-sm text-gray-500">
      <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
        <span>&copy; {YEAR} SecureTheBag</span>
        <Link to="/terms" className="hover:text-gray-700 hover:underline">
          Terms
        </Link>
        <Link to="/privacy" className="hover:text-gray-700 hover:underline">
          Privacy
        </Link>
      </div>
    </footer>
  );
}
